var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("emd-modal", {
    attrs: { open: _vm.show, "has-header": "" },
    on: { close: () => _vm.$emit("onCancel") },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c(
              "h3",
              {
                staticClass:
                  "emd-text _color_default _type_caption _size_section",
              },
              [_vm._v(" " + _vm._s(_vm.$t("title")) + " ")]
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "content",
        fn: function () {
          return [
            _c("emd-text", { attrs: { size: "regular" } }, [
              _vm._v(" " + _vm._s(_vm.$t("content.phrase-1")) + " "),
              _c("b", { staticClass: "_type_bold" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("content.phrase-2")) +
                    " " +
                    _vm._s(_vm.item.start) +
                    " " +
                    _vm._s(_vm.$t("content.phrase-3")) +
                    " " +
                    _vm._s(_vm.item.end) +
                    ". "
                ),
              ]),
              _vm._v(" " + _vm._s(_vm.$t("content.phrase-4")) + " "),
            ]),
            _c(
              "div",
              { staticClass: "eu-flex eu-justify_end" },
              [
                _c(
                  "emd-button",
                  {
                    staticClass: "eu-mr_2",
                    attrs: { color: "primary", type: "text" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("onCancel")
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("button-1")))]
                ),
                _c(
                  "emd-button",
                  {
                    attrs: { color: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("onCopy", _vm.item)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("button-2")))]
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }